import EnvConfig from './env.config';

export default class Logger {
  static DEBUG = 'DEBUG';

  static INFO = 'INFO';

  static WARNING = 'WARNING';

  static ERROR = 'ERROR';

  static send(event) {
    if (EnvConfig.loggly.enabled) {
      // eslint-disable-next-line
      var _LTracker = window._LTracker || [];
      _LTracker.push({
        ...event,
        location: {
          URL: window.location.href
        }
      });
    }
  }

  static debug(trace) {
    Logger.send({
      ...trace,
      level: Logger.DEBUG
    });
  }

  static info(trace) {
    Logger.send({
      ...trace,
      level: Logger.INFO,
    });
  }

  static warning(trace) {
    Logger.send({
      ...trace,
      level: Logger.WARNING
    });
  }

  static error(trace) {
    Logger.send({
      ...trace,
      level: Logger.ERROR
    });
  }
}
